import React from 'react';

export default function LoadMoreRowsTag({ loading }: { loading: boolean }) {
  if (!loading) {
    return null;
  }
  return <div className="load-more-rows-tag">Loading more rows...</div>;
}
